import React from 'react'

interface LocationDisplayProps {
  location:
    | {
        name?: string
        addressLine1?: string
        addressLine2?: string
        city?: string
        zipCode?: string
        state?: {
          name?: string
        }
        country?: {
          code?: string
        }
      }
    | null
    | undefined
}

export const LocationDisplay: React.FC<LocationDisplayProps> = ({location}) => {
  if (!location) return null

  return (
    <div className='fs-6 fw-bold'>
      {location?.name && <div className='mb-2'>{location?.name}</div>}
      {location?.addressLine1 && <div>{location?.addressLine1}</div>}
      {location?.addressLine2 && <div>{location?.addressLine2}</div>}
      {(location?.city ||
        location?.zipCode ||
        location?.state?.name ||
        location?.country?.code) && (
        <div>
          {location?.city && <span>{location?.city}</span>}
          {location?.zipCode && <span>, {location?.zipCode}</span>}
          {location?.state?.name && <span>, {location?.state?.name}</span>}
          {location?.country?.code && <span>, {location?.country?.code}</span>}
        </div>
      )}
    </div>
  )
}

export default LocationDisplay
